import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import classes from "./StatusPill.module.css"

export type TRecordingPhase = "prerecord" | "recording" | "paused" | "finalizing"

interface IProps {
  phase: TRecordingPhase
}

/**
 * Phase chip for the recording top bar. The live "Recording" label lives next
 * to the timer, so Topbar omits this pill while `phase === "recording"`.
 */
export function StatusPill({ phase }: IProps): React.JSX.Element {
  const { i18n } = useLingui()

  if (phase === "recording") {
    return (
      <span className={`${classes.pill} ${classes.pillRecording}`}>
        <span className={classes.dot} />
        {i18n._(msg`Recording`)}
      </span>
    )
  }

  if (phase === "paused") {
    return (
      <span className={`${classes.pill} ${classes.pillPaused}`}>
        <span className={classes.dot} />
        {i18n._(msg`Paused`)}
      </span>
    )
  }

  if (phase === "finalizing") {
    return (
      <span className={`${classes.pill} ${classes.pillFinalizing}`}>
        <span className={classes.dot} />
        {i18n._(msg`Finishing`)}
      </span>
    )
  }

  return (
    <span className={`${classes.pill} ${classes.pillReady}`}>
      <span className={classes.dot} />
      {i18n._(msg`Ready`)}
    </span>
  )
}
